(function(moment) {
    'use strict';

    var convertDate = document.querySelectorAll("[gr-date]"),
        now = moment(),
        today = now.clone().startOf('day'),
        yesterday = now.clone().subtract(1, 'days').startOf('day'),
        twodays = now.clone().subtract(2, 'days').startOf('day'),
        lang = document.documentElement.getAttribute('lang');

    for (var indexDate = 0, maxDate = convertDate.length; indexDate < maxDate; indexDate++) {

        var blogDate = convertDate[indexDate].getAttribute("gr-date");

        if ( isToday(moment(blogDate)) ) {
            if (lang == 'fr') {
                convertDate[indexDate].innerText = "Aujourd'hui";
            }
            else if (lang == 'en') {
                convertDate[indexDate].innerText = "Today";
            }
        }
        else if ( isYesterday(moment(blogDate)) ) {
            if (lang == 'fr') {
                convertDate[indexDate].innerText = "Publié il y a 1 jour";
            }
            else if (lang == 'en') {
                convertDate[indexDate].innerText = "Posted 1 day ago";
            }

        }
        else if ( since2days(moment(blogDate)) ) {
            if (lang == 'fr') {
                convertDate[indexDate].innerText = "Publié il y a 2 jours";
            }
            else if (lang == 'en') {
                convertDate[indexDate].innerText = "Posted 2 days ago";
            }
        }
        else {
            return false;
        }
    }

    function isToday(momentDate) {
        return momentDate.isSame(today, 'd');
    }

    function isYesterday(momentDate) {
        return momentDate.isSame(yesterday, 'd');
    }

    function since2days(momentDate) {
        return momentDate.isSame(twodays, 'd');
    }
})(require('moment'));
